export const fr = {
    translation: {
        b: {
            cancel: 'Annuler',
            confirm: 'Confirmer',
            send: 'Envoyer',
            done: 'Terminé',
            close: 'Fermer',
            clear: 'Effacer',
            copy_link: 'Copier le lien',
            export: 'Exporter',
            delete: 'Supprimer',
            delete_confirm: 'Confirmer la suppression',
            duplicate: 'Dupliquer',
            share: 'Partager',
            sign_in: 'Se connecter',
            sign_up: 'S’inscrire',
            email_address: 'Adresse e-mail',
            yes: 'Oui',
            no: 'Non',
            back: 'Retour',
            upgrade: 'Mettre à niveau',
            remove: 'Retirer',
            restore: 'Restaurer',
            archive: 'Archiver',
            rename: 'Renommer',
            leave: 'Quitter',
            import: 'Importer',
            continue: 'Continuer',
            settings: 'Paramètres',
            log_out: 'Se déconnecter',
            invite: 'Inviter',
            invited: 'Invité',
        },
        roles: {
            view: 'Lecteur',
            comment: 'Commentateur',
            edit: 'Éditeur',
            admin: 'Administrateur',
            owner: 'Propriétaire',
            member: 'Membre',
            remove: 'Retirer',
            more_roles: 'Plus de rôles...',
            change_role: 'Changer de rôle...',
            remove_access: 'Retirer l’accès...',
            remove_invite: 'Retirer l’invitation...',
        },
        db_engine: {
            basic: 'SQL basique',
            general: 'SQL général',
        },
        socket_status: {
            reconnecting: 'Reconnexion...',
            offline: 'Vous êtes hors ligne. Reconnexion...',
        },
        loader: {
            diagram: 'Chargement du diagramme...',
        },
        m_languages: {
            title: 'Langues',
            subtitle: 'Choisissez une langue'
        },
        m_feedback: {
            feature: {
                name: 'Demande de fonctionnalité',
                desc: 'Il vous manque une fonctionnalité ? Dites-le nous — vos idées comptent'
            },
            feedback: {
                name: 'Partagez votre avis',
                desc: 'Nous aimerions beaucoup savoir ce que vous en pensez'
            },
            support: {
                name: 'Assistance',
                desc: 'Quelque chose ne fonctionne pas ? Dites-le nous — nous réglerons cela rapidement',
            },
            bug: {
                name: 'Signaler un problème',
                desc: 'Quelque chose ne va pas tout à fait ? Signalez-le — nous nous en occuperons rapidement',
            },
            integration: {
                name: 'Demander une intégration',
                desc: 'Vos retours comptent énormément pour nous — laissez-nous un petit message',
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Merci pour votre suggestion !',
                desc: 'Merci d’avoir pris le temps de partager votre avis — cela nous aide à améliorer le produit.'
            },
            feedback: {
                name: 'Merci pour votre retour !',
                desc: 'Merci d’avoir pris le temps de partager votre avis — cela nous aide à améliorer le produit.'
            },
            support: {
                name: 'Merci de nous avoir contactés !',
                desc: 'Merci d’avoir contacté notre assistance — nous examinerons votre demande et vous répondrons dès que possible.',
            },
            bug: {
                name: 'Merci pour votre signalement !',
                desc: 'Merci de nous avoir signalé ceci — cela nous aide à résoudre les problèmes plus vite et à améliorer l’expérience en continu.',
            },
            contact: {
                name: 'Merci de nous avoir contactés !',
                desc: 'Nous avons bien reçu votre message et vous répondrons dès que possible.',
            },
            invite_people: {
                name: 'Invitation envoyée avec succès !',
                desc: 'Merci d’en avoir parlé autour de vous — nous avons hâte de les accueillir.',
            },
            integration: {
                name: 'Merci pour votre suggestion !',
                desc: 'Merci d’avoir pris le temps de partager votre avis — cela nous aide à améliorer le produit.',
            },
        },
        m_diagram_details: {
            name_place: 'Saisir le nom du projet',
            desc_place: 'Saisir la description du projet'
        },
        m_quick_share: {
            title: 'Partage rapide',
            subtitle: '(Partage par lien)'
        },
        m_export_img: {
            title: 'Exporter l’image'
        },
        search_menu: {
            placeholder: 'Rechercher des tables, colonnes, types...',
            hint: '',
            no_results: 'Aucun résultat',
            quick_results: 'Résultats rapides pour',
            untitled: 'sans titre',
            command_tag: 'commande',
            section_tables: 'Tables',
            section_columns: 'Colonnes',
            section_canvas: 'Plan de travail',
            section_export: 'Exporter',
            section_preferences: 'Préférences',
            section_settings: 'Paramètres',
            type_table: 'table',
            type_note: 'remarque',
            cmd_new_table: 'Créer une nouvelle table...',
            cmd_new_note: 'Créer une nouvelle remarque...',
            cmd_new_line: 'Créer une nouvelle ligne...',
            cmd_new_area: 'Créer une nouvelle zone...',
            cmd_export_image: 'Exporter une image...',
            cmd_export_sql: 'Exporter le code SQL...',
            cmd_grid_style: 'Modifier la vue en grille...',
        },
        canvas_table: {
            more_column: 'colonne supplémentaire',
            more_columns: 'colonnes supplémentaires',
            tooltip_table: 'Table',
            tooltip_indexes: 'Index',
            tooltip_enum: 'Enum',
            tooltip_default: 'Par défaut',
            tooltip_generated: 'Généré',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Exporter le code {{db_engine}}',
            download_file: 'Télécharger le fichier',
            copy_code: 'Copier le code'
        },
        m_sign_in_remind: {
            title: 'Merci d’essayer DB Design',
            subtitle: 'Connectez-vous ou inscrivez-vous pour augmenter le nombre maximal de tables, enregistrer des diagrammes et débloquer plus de fonctionnalités.'
        },
        m_sign_in_restrict: {
            title: 'Connectez-vous pour en faire plus',
            subtitle: 'Connectez-vous ou inscrivez-vous pour augmenter les limites de tables, enregistrer des diagrammes et débloquer plus de fonctionnalités.'
        },
        m_new_diagram: {
            title: 'Nouveau diagramme',
            subtitle: 'Choisissez un moteur de base de données',
            open_diagram: 'Ouvrir le diagramme',
            create_diagram: 'Créer le diagramme',
            no_workspace: 'Créez d’abord un espace de travail pour démarrer un diagramme.',
            build_something_new: 'Créons quelque chose de nouveau',
            create_diagram_section: 'Créer un diagramme',
            clone_template_btn: 'Dupliquer le modèle',
        },
        m_diagram_name: {
            enter_new_name: 'Saisissez un nouveau nom de diagramme',
        },
        m_diagram_clone: {
            header: 'Dupliquer le diagramme',
            copy_of_title: 'Copie de {{title}}',
        },
        m_diagram_rename: {
            header: 'Renommer le diagramme',
        },
        m_template_clone: {
            header: 'Créer un diagramme à partir d’un modèle',
        },
        m_diagram_delete: {
            header: 'Supprimer le diagramme',
            desc_prefix: 'Sera supprimé : ',
        },
        m_diagram_archive: {
            header: 'Archiver le diagramme',
            desc_prefix: 'Sera archivé : ',
        },
        m_diagram_restore: {
            header: 'Restaurer le diagramme',
            desc_prefix: 'Sera restauré : ',
        },
        m_diagram_import: {
            sql_name: 'Importer du code SQL',
            dbml_name: 'Importer du code DBML',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: 'Nous serions ravis de connaître votre avis !',
        },
        m_diagram_not_found: {
            header: 'Diagramme introuvable',
            desc: 'Nous n’avons pas trouvé le diagramme que vous recherchez.',
            back_to_app: 'Retour à l’application',
        },
        m_diagram_share: {
            header: 'Partager le diagramme – {{title}}',
            owner_only_invite: 'Seul le propriétaire peut inviter de nouveaux membres',
            invited_to_workspace: 'Invité dans l’espace de travail',
            you: 'vous',
            email_placeholder: 'Saisir l’e-mail',
            email_already_in_list: 'cet e-mail est déjà dans la liste',
            will_be_invited_to_workspace: 'sera invité dans l’espace de travail',
        },
        m_invite_people: {
            header: 'Inviter dans l’espace de travail',
        },
        m_invite_revoke: {
            header: 'Retirer l’invitation',
            desc_prefix: 'Retirer l’invitation de ',
            desc_suffix: 'L’invitation cessera de fonctionner.',
        },
        m_member_remove: {
            header: 'Retirer le membre',
            desc_prefix: 'Retirer ',
            desc_suffix: ' de cet espace de travail ? Il ou elle perdra l’accès.',
        },
        m_template_details: {
            preview: 'Aperçu',
            use_template: 'Utiliser le modèle',
        },
        m_workspace_create: {
            header: 'Créer un nouvel espace de travail',
            name_label: 'Nom',
            setup_config_label: 'Configuration',
            setup_config_value: 'Espace de travail vide',
            template_structure_label: 'Modèle/Structure',
            template_structure_value: 'Précharger la structure',
            placeholder: 'Saisir le nom de l’espace de travail',
            create_button: 'Créer l’espace de travail',
            creating: 'Création de votre espace de travail...',
        },
        m_workspace_delete: {
            header: 'Supprimer l’espace de travail',
            desc_prefix: 'Sera définitivement supprimé : ',
            confirm_prefix: 'Saisissez ',
            confirm_suffix: ' pour confirmer.',
        },
        m_workspace_leave: {
            header: 'Quitter l’espace de travail',
            desc_prefix: 'Cela vous retirera de ',
            desc_suffix: '. Vous devrez être réinvité pour le rejoindre.',
        },
        m_workspace_menu: {
            manage_members: 'Gérer les membres',
            switch_workspace: 'Changer d’espace de travail',
            workspaces_label: 'Espaces de travail',
            create_workspace: 'Créer un espace de travail...',
            switching: 'Changement en cours',
        },
        m_profile_menu: {
            profile: 'Profil',
            onboarding: 'Prise en main',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Faites passer votre collaboration au niveau supérieur', description: 'Passez à un forfait supérieur pour débloquer plus de rôles de partage comme Administrateur, Éditeur, Commentateur, Lecteur.' },
            workspaces: { title: 'Vous grandissez vite !', description: 'Passez à un forfait supérieur pour créer et gérer davantage d’espaces de travail pour vos projets et équipes.' },
            workspaces_canvas: { title: 'Développez vos espaces de travail', description: 'Passez à un forfait supérieur pour créer et gérer davantage d’espaces de travail pour vos projets et équipes.' },
            members: { title: 'Collaborez à grande échelle', description: 'Passez à un forfait supérieur pour intégrer davantage de membres à votre espace de travail et collaborer plus efficacement.' },
            diagrams: { title: 'Vous grandissez vite !', description: 'Passez à un forfait supérieur pour créer plus de diagrammes et développer vos projets en toute confiance.' },
            tables: { title: 'Créez sans limites', description: 'Passez à un forfait supérieur pour ajouter plus de tables et continuer à créer des diagrammes plus grands et plus détaillés.' },
            columns: { title: 'Créez sans limites', description: 'Passez à un forfait supérieur pour ajouter plus de colonnes et continuer à créer des diagrammes plus grands et plus détaillés.' },
            notes: { title: 'Créez sans limites', description: 'Passez à un forfait supérieur pour ajouter plus de remarques et continuer à créer des diagrammes plus grands et plus détaillés.' },
            areas: { title: 'Créez sans limites', description: 'Passez à un forfait supérieur pour ajouter plus de zones et continuer à créer des diagrammes plus grands et plus détaillés.' },
            pens: { title: 'Créez sans limites', description: 'Passez à un forfait supérieur pour ajouter plus de dessins et continuer à créer des diagrammes plus grands et plus détaillés.' },
            default_title: 'Faites passer votre collaboration au niveau supérieur',
            default_title_canvas: 'Améliorez vos performances',
        },
        m_pricing_plans: {
            title: 'Passer à un forfait supérieur',
            subtitle: 'Vous pouvez toujours changer de forfait plus tard',
            monthly: 'Mensuel',
            annually: 'Annuel',
            billed_annually: 'Facturation annuelle',
            billed_monthly: 'Facturation mensuelle',
            free_for_everyone: 'Gratuit pour tous',
            current_plan: 'Forfait actuel',
            will_be_available_soon: 'Bientôt disponible',
            price_period_user_month: '/utilisateur/mois',
            plan_free: {
                name: 'Gratuit',
                button: 'Changer de forfait',
                feature_realtime: 'Collaboration en temps réel',
                feature_members: '4 membres / espace de travail',
                feature_diagrams: '4 diagrammes / espace de travail',
                feature_tables: '40 tables / diagramme',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Toutes les fonctionnalités Gratuit +',
                feature_members: 'Membres illimités',
                feature_diagrams: 'Diagrammes illimités',
                feature_tables: 'Tables illimitées',
                feature_history: 'Historique des versions',
                feature_admin_roles: 'Rôles administrateur',
            },
        },
        sidebar: {
            new: 'Nouveau',
            pinned_diagrams: 'Diagrammes épinglés',
            pin_hint: 'Épinglez des diagrammes pour les voir ici',
            expand_sidebar: 'Développer la barre latérale',
            home_aria: 'Accueil DB Design',
            open_menu: 'Ouvrir le menu',
            close_menu: 'Fermer le menu',
            sidebar_menu_aria: 'Menu de la barre latérale',
            plan_suffix: 'forfait',
            diagram_options: 'Options du diagramme',
            pin: 'Épingler',
            unpin: 'Désépingler',
            edit_details: 'Modifier les détails',
            see_details: 'Voir les détails',
            invite_people: 'Inviter des personnes',
            collapse_sidebar: 'Réduire la barre latérale',
            close_sidebar: 'Fermer la barre latérale',
            open_sidebar: 'Ouvrir la barre latérale',
            open_new_tab: 'Ouvrir dans un nouvel onglet',
        },
        focus_controls: {
            show_top: 'Afficher les contrôles du haut',
            hide_top: 'Masquer les contrôles du haut',
            show_left: 'Afficher les contrôles de gauche',
            hide_left: 'Masquer les contrôles de gauche',
        },
        m_keyboard_shortcuts: {
            title: 'Raccourcis clavier',
            general: {
                title1: 'Général',
                title2: '',
                items: {
                    new_diagram: 'Créer un diagramme',
                    new_chat: 'Nouvelle discussion',
                    search: 'Actions rapides ou recherche',
                    preferences: 'Préférences',
                    settings: 'Paramètres',
                    keyboard_shortcuts: 'Raccourcis clavier',
                    toggle_sidebar: 'Afficher/masquer la barre latérale',
                    toggle_theme: 'Changer de thème',
                },
            },
            ctrl_left: {
                title1: 'Contrôles',
                title2: '(Gauche)',
                items: {
                    mouse_sel: 'Mode sélection / Mode main',
                    table: 'Table',
                    line: 'Ligne',
                    area: 'Zone',
                    note: 'Remarque',
                    comment: 'Commentaire',
                    pen: 'Stylo',
                    undo: 'Annuler',
                    redo: 'Rétablir'
                }
            },
            ctrl_top_left: {
                title1: 'Contrôles',
                title2: '(En haut à gauche)',
                items: {
                    export_img: 'Exporter une image',
                    search: 'Rechercher',
                    editor_panel: 'Panneau de l’éditeur',
                    zoom_to_fit: 'Adapter à l’écran',
                }
            },
            ctrl_bottom_right: {
                title1: 'Contrôles',
                title2: '(En bas à droite)',
                items: {
                    minimap: 'Mini-carte',
                    full_screen: 'Plein écran',
                    zoom_in: 'Zoom avant',
                    zoom_out: 'Zoom arrière',
                    zoom_100: 'Zoom à 100 %'
                }
            },
            ctx_tab: {
                title1: 'Menu contextuel',
                title2: '(Table)',
                items: {
                    dupl_tab: 'Dupliquer la table',
                    del_tab: 'Supprimer la table'
                }
            },
            ctx_del_tab: {
                title1: 'Menu contextuel',
                title2: '(Supprimer la table)',
                items: {
                    yes: 'Oui',
                    no: 'Non'
                }
            },
            ctx_tab_col: {
                title1: 'Menu contextuel',
                title2: '(Colonne)', // (Colonne de table)
                items: {
                    add_col_below: 'Ajouter une colonne en dessous',
                    focus_col_above: 'Focus sur la colonne au-dessus',
                    focus_col_below: 'Focus sur la colonne au-dessous',
                    move_col_up: 'Monter la colonne',
                    move_col_down: 'Descendre la colonne',
                    dupl_col: 'Dupliquer la colonne',
                    del_col: 'Supprimer la colonne'
                }
            },
            ctx_line: {
                title1: 'Menu contextuel',
                title2: '(Ligne)',
                items: {
                    del_line: 'Supprimer la ligne'
                }
            },
            ctx_area: {
                title1: 'Menu contextuel',
                title2: '(Zone)',
                items: {
                    dupl_area: 'Dupliquer la zone',
                    del_area: 'Supprimer la zone'
                }
            },
            ctx_multi: {
                title1: 'Menu contextuel',
                title2: '(Sélection multiple)',
                items: {
                    select_all: 'Sélectionner tous les éléments',
                    create_area_for_select_els: 'Créer une zone pour les éléments sélectionnés',
                    dupl_select_els: 'Dupliquer les éléments sélectionnés',
                    del_select_els: 'Supprimer les éléments sélectionnés'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Sélection à la souris',
                table: 'Table',
                line: 'Ligne',
                area: 'Zone',
                note: 'Remarque',
                comment: 'Commentaire',
                pen: 'Stylo',
                undo: 'Annuler',
                redo: 'Rétablir'
            },
            ctrl_top_left: {
                home: 'Accueil',
                name: 'Informations du diagramme',
                editor: 'Éditeur',
                search: 'Recherche',
                export: 'Options d’export',
                view_mode: 'Mode d’affichage',
                zoom_to_fit: 'Adapter à l’écran',
                grid: 'Vue en grille',
                history: 'Historique',
                main_menu: 'Menu principal',
                new_diagram: 'Nouveau diagramme',
            },
            ctrl_top_right: {
                feature_req: 'Demande de fonctionnalité',
                feedback: 'Envoyer un commentaire',
                sign_in: 'Se connecter',
                quick_share: 'Partage rapide'
            },
            ctrl_bottom_right: {
                full_screen: 'Plein écran',
                minimap: 'Mini-carte',
                zoom_out: 'Zoom arrière',
                zoom_100: 'Zoom à 100 %',
                zoom_in: 'Zoom avant',
                info: 'Informations & ressources'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Par défaut',
                        blue: 'Bleu',
                        green: 'Vert',
                        red: 'Rouge',
                        purple: 'Violet',
                        violet: 'Violette'
                    },
                    borders: {
                        none: 'Aucune',
                        solid: 'Continu',
                        dashed: 'Tirets',
                        dotted: 'Pointillés'
                    },
                    color: 'Couleur',
                    border: 'Bordure',
                    description: 'Description',
                    description_table_place: 'Description de table',
                    description_column_place: 'Description de colonne',
                    description_line_place: 'Description de ligne',
                    description_note_place: 'Description de remarque',
                    description_area_place: 'Description de zone',
                    description_pen_place: 'Description du tracé',
                    hide_menu: 'Masquer le menu',
                    show_menu: 'Afficher le menu'
                },
                tab_col: {
                    add_col_below: 'Ajouter une colonne en dessous',
                    add_col_above: 'Ajouter une colonne au-dessus',
                    key: 'Key',
                    keys: {
                        none: 'Aucune',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Aucun',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Descendre la colonne',
                    move_col_up: 'Monter la colonne',
                    more_functions: 'Fonctions supplémentaires'
                },
                line: {
                    change_connects: 'Modifier les connecteurs',
                    connects: {
                        empty: 'Vide',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtrer les éléments'
                },
                note: {
                    link_placeholder: 'Saisir un lien',
                    link_apply: 'Ajouter',
                    link_remove: 'Retirer',
                    link_edit: 'Modifier',
                    link_needs_selection: 'Sélectionnez du texte à lier',
                    bulleted_list: 'Liste',
                    numbered_list: 'Liste numérotée',
                    font_style: 'Style de police',
                    alignment: 'Alignement',
                    align_left: 'Gauche',
                    align_center: 'Centre',
                    align_right: 'Droite',
                    link: 'Lien',
                    monospace: 'Monospace',
                    bold: 'Gras',
                    italic: 'Italique',
                    underline: 'Souligné',
                    strikethrough: 'Barré',
                },
                multi: {
                    filter: 'Filtrer la sélection',
                    create_area: 'Créer une zone'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Complet',
            keys_only: 'Clés uniquement',
            names_only: 'Noms uniquement'
        },
        dropdown_ctrl_grid: {
            none: 'Aucun',
            lines: 'Lignes',
            dots: 'Points',
        },
        dropdown_ctrl_export: {
            export_img: 'Exporter une image',
            export_code: 'Exporter le code SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Retour à l’accueil',
            sign_in: 'Se connecter',
            preferences: 'Préférences',
            new_project: 'Nouveau projet',
            import_diagram: 'Importer un diagramme',
            duplicate_diagram: 'Dupliquer le diagramme',
            keyboard_shortcuts: 'Raccourcis clavier',
            languages: 'Langues',
            view: 'Affichage',
            upgrade_plan: 'Changer de forfait',
            language: 'Langue',
            mouse_trackpad: 'Souris ou pavé tactile',
            background_color: 'Couleur d’arrière-plan',
            grid_layout: 'Disposition de la grille',
            view_mode: 'Mode d’affichage',
            show_align_lines: 'Afficher les lignes d’alignement',
            show_members_cursors: 'Afficher les curseurs des membres',
            show_comments: 'Afficher les commentaires',
            undo_redo_controls: 'Contrôles annuler/rétablir',
            show_scrollbars: 'Afficher les barres de défilement',
            opt_auto: 'Automatique',
            opt_trackpad: 'Pavé tactile',
            opt_mouse: 'Souris',
            opt_default: 'Sombre (par défaut)',
            opt_gray: 'Gris',
            opt_blue: 'Bleu',
            opt_purple: 'Violet',
            opt_violet: 'Violette',
            opt_green: 'Vert',
            opt_red: 'Rouge',
            opt_yellow: 'Jaune',
            opt_dots: 'Points',
            opt_lines: 'Lignes',
            opt_none: 'Aucun',
            opt_full: 'Complet',
            opt_keys: 'Clés',
            opt_names: 'Noms',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Commentaires',
            keyboard_shortcuts: 'Raccourcis clavier',
            languages: 'Langues',
            homepage: 'Page d’accueil'
        },
        n: {
            default: 'Chargement…',
            file_ready_to_download: 'Le fichier est prêt à être téléchargé',
            code_copied: 'Le code a été copié',
            link_copied: 'Le lien a été copié',
            username_copied: 'Nom d’utilisateur copié dans le presse-papiers',
            email_copied: 'E-mail copié dans le presse-papiers',
            please_enter_message: 'Veuillez saisir un message',
            invalid_email: 'L’adresse e-mail n’est pas valide',
            note_link_unsupported_protocol: 'Type de lien non pris en charge. Utilisez https, http, mailto.',
            something_wrong_contact: 'Un problème est survenu. Veuillez recharger la page ou nous contacter.',
            something_wrong: 'Un problème est survenu. Veuillez recharger la page.',
            sending: 'Envoi…',
            request_sent: 'La demande a été envoyée. Merci !',

            please_enter_email: 'Saisir une adresse e-mail',
            changing: 'Modification...',
            role_changed: 'Rôle modifié',
            removing: 'Retrait...',
            member_removed: 'Membre retiré',
            inviting: 'Invitation...',
            invite_sent: 'Invitation envoyée',
            added_to_diagram: 'Ajouté au diagramme',
            invite_removed: 'Invitation retirée',
            role_not_allowed_on_plan: 'Ce rôle n’est pas disponible avec votre forfait. Passez à un forfait supérieur pour l’attribuer.',
            already_diagram_member: 'Cette personne a déjà accès au diagramme.',
            cannot_invite_to_workspace: 'Demandez à un administrateur de l’espace de travail d’inviter cette personne.',
            saving: 'Enregistrement...',
            saved: 'Enregistré',
            diagram_renamed: 'Diagramme renommé',
            diagram_updated: 'Diagramme mis à jour',
            duplicating: 'Duplication...',
            diagram_duplicated: 'Diagramme dupliqué',
            deleting: 'Suppression...',
            diagram_archived: 'Diagramme archivé',
            diagram_deleted: 'Diagramme supprimé',
            restoring: 'Restauration...',
            diagram_restored: 'Diagramme restauré',
            diagram_pinned: 'Diagramme épinglé',
            diagram_unpinned: 'Diagramme désépinglé',
            creating: 'Création...',
            diagram_created: 'Diagramme créé',
            forbidden: 'Vous n’avez pas accès à cela.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Déjà membre de l’espace de travail',
            cannot_invite_self: 'Vous ne pouvez pas vous inviter vous-même',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagramme introuvable.',
            has_diagram_members: 'Le diagramme a des membres actifs',
            seat_limit_reached: 'Vous avez atteint la limite de sièges de votre forfait. Passez à un forfait supérieur pour inviter plus de personnes.',
            feature_not_in_plan: 'Cette fonctionnalité n’est pas incluse dans votre forfait actuel.',
            subscription_expired: 'Votre abonnement a expiré. Renouvelez-le pour continuer à l’utiliser.',
            subscription_inactive: 'Votre abonnement est inactif. Veuillez mettre à jour votre facturation.',
            plan_limit_generic: 'Votre forfait ne permet pas cette action. Passez à un forfait supérieur pour continuer.',

            // Auth / profile
            session_expired: 'Votre session a expiré — veuillez vous reconnecter.',
            profile_updated: 'Profil mis à jour',
            profile_update_failed: 'Échec de la mise à jour du profil.',
            account_delete_failed: 'Échec de la suppression du compte.',

            // Preferences
            couldnt_save: 'Impossible d’enregistrer les modifications',
            try_again: 'Un problème est survenu. Veuillez réessayer.',

            // Workspace
            not_workspace_member: 'Vous n’êtes pas membre de cet espace de travail.',
            workspace_switch_failed: 'Impossible de changer d’espace de travail. Veuillez réessayer.',
            workspace_create_failed: 'Impossible de créer l’espace de travail. Veuillez réessayer.',
            invalid_workspace_name: 'Nom d’espace de travail invalide',
            workspace_updated: 'Espace de travail mis à jour',
            workspace_update_failed: 'Impossible de mettre à jour l’espace de travail. Veuillez réessayer.',
            last_owner_cannot_leave: 'Vous êtes le seul propriétaire. Désignez un autre propriétaire ou supprimez l’espace de travail avant de le quitter.',
            workspace_leave_failed: 'Impossible de quitter l’espace de travail. Veuillez réessayer.',
            workspace_delete_forbidden: 'Seul le propriétaire de l’espace de travail peut le supprimer.',
            workspace_has_active_billing: 'Annulez l’abonnement de cet espace de travail avant de le supprimer.',
            workspace_deleted: 'Espace de travail supprimé',
            workspace_delete_failed: 'Impossible de supprimer l’espace de travail. Veuillez réessayer.',
            member_remove_forbidden: 'Vous n’avez pas la permission de retirer ce membre.',
            member_remove_failed: 'Impossible de retirer le membre. Veuillez réessayer.',
            cannot_remove_self: 'Utilisez « Quitter l’espace de travail » pour vous retirer vous-même.',
            cannot_remove_last_owner: 'Un espace de travail doit toujours avoir un propriétaire. Désignez d’abord un autre propriétaire.',
            invite_revoke_forbidden: 'Vous n’avez pas la permission de révoquer cette invitation.',
            invite_revoke_failed: 'Impossible de révoquer l’invitation. Veuillez réessayer.',
        },
        dashboard: {
            doc_title: 'Diagrammes',
            filter_all: 'Tous',
            filter_mydiagrams: 'Mes diagrammes',
            filter_shared: 'Partagés avec moi',
            filter_archived: 'Archivés',
            empty_all: 'Aucun diagramme dans "Tous les diagrammes"',
            empty_mydiagrams: 'Aucun diagramme dans "Mes diagrammes"',
            empty_shared: 'Aucun diagramme dans "Partagés avec moi"',
            empty_archived: 'Aucun diagramme dans "Archivés"',
            example_diagram_badge: 'Diagramme d’exemple',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Retour à l’application',
                group_personal: 'Personnel',
                group_organization: 'Organisation',
                billing: 'Facturation',
            },
            profile: {
                member_since: 'Membre depuis {{date}}',
                general: 'Général',
                email: 'E-mail',
                full_name: 'Nom complet',
                full_name_placeholder: 'Saisissez votre nom',
                account_protection: 'Protection du compte',
                mfa_label: 'Authentification multifacteur (MFA)',
                mfa_sub: 'Couche de sécurité supplémentaire pour le compte · Bientôt disponible',
                mfa_enable: 'Activer la MFA',
                mfa_soon_tooltip: 'Bientôt disponible',
                workspace_access: 'Accès à l’espace de travail',
                leave_workspace: 'Quitter l’espace de travail',
                leave_workspace_sub: 'Vous retirer de l’espace de travail',
                leave_owner_tooltip: 'Transférez la propriété avant de quitter l’espace de travail',
            },
            workspace: {
                header: 'Espace de travail',
                general: 'Général',
                name_label: 'Nom de l’espace de travail',
                name_placeholder: 'nom de l’espace de travail',
                stat_member_singular: 'Membre',
                stat_member_plural: 'Membres',
                stat_team_singular: 'Équipe',
                stat_team_plural: 'Équipes',
                members_section: 'Membres',
                no_members: 'Aucun membre',
                count_member_singular: 'membre',
                count_member_plural: 'membres',
                view_members_btn: 'Voir les membres',
                danger_zone: 'Zone de danger',
                delete_workspace: 'Supprimer l’espace de travail',
                delete_workspace_sub: 'Cela supprimera définitivement l’espace de travail',
                delete_owner_only_tooltip: 'Seuls les propriétaires peuvent supprimer des espaces de travail',
                delete_cancel_sub_tooltip: 'Annulez votre abonnement avant de supprimer l’espace de travail',
            },
            members: {
                header: 'Membres',
                col_name: 'Nom',
                col_email: 'E-mail',
                col_role: 'Rôle',
                col_joined: 'Rejoint le',
                active_members: 'Membres actifs',
                invited_section: 'Invités',
                no_members: 'Aucun membre pour le moment.',
                options_aria: 'Options',
                leave_workspace_item: 'Quitter l’espace de travail...',
                remove_member_item: 'Retirer le membre...',
                remove_owner_only_tooltip: 'Seuls les propriétaires peuvent retirer des membres',
                remove_owner_row_tooltip: 'Le propriétaire ne peut pas être retiré de l’espace de travail',
                remove_invite_item: 'Supprimer l’invitation...',
                role_invited_suffix: '{{role}} (Invité)',
            },
            preferences: {
                section_general: 'Général',
                section_diagram_defaults: 'Paramètres du diagramme',
                section_diagram_views: 'Affichages du diagramme',
                section_notifications: 'Notifications',
                theme_label: 'Thème de l’interface',
                theme_sub: 'Sélectionnez le thème de couleurs de votre interface',
                theme_dark: 'Sombre',
                theme_light: 'Clair',
                theme_system: 'Système',
                language_sub: 'Sélectionnez la langue de votre interface',
                timezone_label: 'Fuseau horaire',
                timezone_sub: 'Sélectionnez votre fuseau horaire',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaï',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Heure du Pacifique',
                    denver: 'GMT-07:00 — Heure des Rocheuses',
                    chicago: 'GMT-06:00 — Heure du Centre',
                    new_york: 'GMT-05:00 — Heure de l’Est',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Açores',
                    london: 'GMT+00:00 — Londres',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyiv, Athènes',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubaï',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — Inde',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Jakarta',
                    shanghai: 'GMT+08:00 — Pékin, Singapour',
                    tokyo: 'GMT+09:00 — Tokyo, Séoul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Choisissez les commandes de navigation du canevas',
                background_sub: 'Choisissez une couleur d’arrière-plan pour le canevas',
                grid_sub: 'Choisissez la disposition de la grille du canevas',
                show_align_lines_sub: 'Afficher les lignes lors de l’alignement des objets',
                show_cursors_sub: 'Afficher les curseurs des autres collaborateurs',
                show_comments_sub: 'Afficher les commentaires sur le canevas',
                show_scrollbars_sub: 'Afficher les barres de défilement lors de la navigation dans le canevas',
                show_undo_redo_label: 'Afficher les commandes annuler/rétablir',
                show_undo_redo_sub: 'Afficher les commandes pour annuler et rétablir les modifications',
                notif_shared_label: 'Diagramme partagé avec moi',
                notif_shared_sub: 'Lorsque quelqu’un partage un diagramme avec moi',
                notif_mentions_label: 'Mentions dans les commentaires',
                notif_mentions_sub: 'Lorsque quelqu’un me @mentionne dans un commentaire',
                notif_updates_label: 'Actualités du produit',
                notif_updates_sub: 'Mises à jour mensuelles sur les nouvelles fonctionnalités et améliorations',
                show: 'Afficher',
                hide: 'Masquer',
                on: 'Activé',
                off: 'Désactivé',
            },
            billing: {
                header: 'Facturation',
                plan_free: 'Forfait gratuit',
                status_current: 'Actuel',
                no_renewal_needed: 'Aucun renouvellement nécessaire',
                payment_header: 'Paiement',
                no_payments: 'Aucun paiement',
                invoices_header: 'Factures',
                no_invoices: 'Aucune facture',
            },
            usage: {
                doc_title: 'Utilisation',
                overview_title: 'Aperçu',
                resource_limits_title: 'Limites de ressources',
                label_diagrams: 'Diagrammes',
                label_tables: 'Tables',
                label_areas: 'Zones',
                label_notes: 'Notes autocollantes',
                label_members: 'Membres',
                label_tables_per_diagram: 'Tables / Diagramme',
                label_areas_per_diagram: 'Zones / Diagramme',
                label_notes_per_diagram: 'Notes / Diagramme',
                need_more_title: 'Besoin de plus ?',
                need_more_free: 'Passez à Basic pour plus de diagrammes, l’historique des versions et une assistance prioritaire.',
                need_more_paid: 'Passez à Professional pour des diagrammes illimités, plus de places et des fonctionnalités avancées.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Page introuvable',
                dont_have_access_to_diagram: 'Vous n’avez pas accès à ce diagramme ou il n’existe peut-être plus.',
                back_home: 'Retour à l’accueil'
            },
            error: {
                title: 'Erreur',
                link_is_invalid: 'Ce lien est invalide ou a été saisi incorrectement.',
                something_wrong: 'Un problème est survenu.',
                back_home: 'Retour à l’accueil',
                please_try_later: 'Veuillez réessayer plus tard',
            },
            billing_success: {
                doc_title: 'Forfait mis à niveau',
                heading: 'Paiement réussi',
                subtitle: 'Votre forfait a été mis à niveau avec succès.',
                cta: 'Commencer à concevoir',
            },
            email_verified: {
                doc_title: 'E-mail vérifié',
            },
            forgot_password: {
                doc_title: 'Mot de passe oublié',
            },
            password_updated: {
                doc_title: 'Mot de passe mis à jour',
            },
            reset_password: {
                doc_title: 'Réinitialiser le mot de passe',
            },
            check_email: {
                doc_title: 'Vérifiez votre e-mail',
            },
            sign_in: {
                doc_title: 'Se connecter à {{product}}',
            },
            sign_up: {
                doc_title: 'S’inscrire sur {{product}}',
            },
        },
    }
};

export const frMeta = {
    lang_origin: 'Français',
    lang_eng: 'French',
    lang_code: 'fr',
};
